// The Detail component of each entity type, keyed like the registry.
// Only the detail dispatcher (EntityDetail.tsx) imports this module: the
// registry itself imports no component, so reading a type's metadata never
// loads the detail components.

import type React from "react";
import type {
  EntityDetailProps,
  EntityTypeKey,
} from "../../types/entityRegistry";
import CapabilityPartDetailView from "../CapabilityPartDetail/CapabilityPartDetailView";
import CategoryDetailView from "../CategoryDetail/CategoryDetailView";
import IncidentDetailView from "../IncidentDetail/IncidentDetailView";
import ClassDetailView from "../KindDetail/ClassDetailView";
import KindDetailView from "../KindDetail/KindDetailView";
import ProductDetailView from "../ProductDetail/ProductDetailView";
import GraphEntityDetail from "./GraphEntityDetail";

// Each component renders its type's whole detail and fetches its own data.
// A registry entry without a line here is a compile error.
export const ENTITY_DETAIL_VIEWS: Record<
  EntityTypeKey,
  React.ComponentType<EntityDetailProps>
> = {
  organization: GraphEntityDetail,
  facility: GraphEntityDetail,
  project: GraphEntityDetail,
  source: GraphEntityDetail,
  product: ProductDetailView,
  category: CategoryDetailView,
  capability_part: CapabilityPartDetailView,
  incident: IncidentDetailView,
  kind: KindDetailView,
  class: ClassDetailView,
};

// The Detail of an id that comes without a type. Such an id names an
// organization, facility, project or source; which one is told from the
// fetched response.
export const UntypedEntityDetail: React.ComponentType<EntityDetailProps> =
  GraphEntityDetail;
